/**
 * Real Feaststar app screenshots.
 *
 * All assets are pre-optimized WebP (see /tmp/optimize_images.py) and served
 * from the frontend's public folder. Original PNGs totaled 9.2 MB; the
 * optimized WebP set is 483 KB (95% smaller) with no visual regression at
 * the sizes we render (phones capped at 310px wide, logos ≤ 128px).
 */
export const APP_SCREENS = {
  // Berlin map / list view — main hero center
  map: "/images/phone-map.webp",
  // Restaurant profile — Landgasthof Sonnenhof Legau with Verifiziert badge + gallery
  restaurant: "/images/phone-restaurant.webp",
  // Quality profile — Sonnenhof Score 87/100 with 5 weighted categories
  quality: "/images/phone-quality.webp",
  // Search / Entdecken — Feaststar logo + Aktueller Standort list view
  search: "/images/phone-search.webp",
  // Saved / Gespeichert — saved restaurants list with hearts
  saved: "/images/phone-saved.webp",
  // Partner restaurant photo (legacy)
  partnerCafe: "/images/partner-cafe.webp",
  // Restaurant detail view — Header with trust score 92/100 + gallery + Founder & Transparenz badges
  restaurantHeader: "/images/phone-restaurant-header.webp",
  // Restaurant detail view — Founder quote + Transparenz description + Qualitäts-Profil 88/100
  restaurantDetails: "/images/phone-restaurant-details.webp",
};

/** Brand logos */
export const LOGOS = {
  wordmark: "/images/logo-wordmark.webp",
  star: "/images/logo-star.webp",
};

/** Alt texts for accessibility. */
export const APP_SCREENS_ALT = {
  map: "Feaststar Karte mit Restaurant-Pins in Berlin",
  restaurant: "Landgasthof Sonnenhof Legau — Feaststar verifizierter Partner mit Bildergalerie",
  quality: "Qualitäts-Profil Landgasthof Sonnenhof — Score 87/100 mit 36 gewichteten Kriterien",
  search: "Feaststar Entdecken-Liste — Restaurants in deiner Nähe",
  saved: "Feaststar Gespeichert — gespeicherte Restaurants mit Herz-Icons",
  partnerCafe: "Feaststar Partner-Restaurant",
  restaurantHeader: "Feaststar Restaurant-Detail — Header mit Vertrauen 92/100, Standort, Verifiziert-Badge und Bildergalerie",
  restaurantDetails: "Feaststar Restaurant-Detail — Founder-Quote, Transparenz-Beschreibung und Qualitäts-Profil 88/100",
};
